import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

import {BreadcrumbService} from '../../../../breadcrumb.service';
import {Player, Project, TelemetryResponse} from '../../../../core/models/';
import {PlayerService, TelemetryService} from '../../../../core/services/';
import {PageRequest} from '../../../../core';
import {TokenService} from '../../../../core/auth/auth-token.service';
import {AuthUser} from '../../../../core/auth/auth-user';
import {ProjectSidebarService} from '../../../../projectsidebar.service';
import {DataTable} from 'primeng/datatable';
import {Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {ConfirmationService} from 'primeng/api';

@Component({
  selector: 'app-project-player-detail',
  templateUrl: './project-player-detail.page.html',
  styleUrls: ['./project-player-detail.page.scss']
})
export class ProjectPlayerDetailPage implements OnInit {
  projectId: string = null;
  project: Project = null;
  playerId: string = null;
  player: Player = null;
  playerQuery: PageRequest = new PageRequest();
  loading: boolean = true;
  displayDialog: boolean = false;
  modalContent: String = '';
  authUser: AuthUser = this.token.whoAmI();
  @ViewChild('dt') dt: DataTable;
  searchTerms = new Subject<string>();
  selectedEvents: any[] = new Array();

  telemetryResponse: TelemetryResponse = new TelemetryResponse();
  telemetryQuery: PageRequest = new PageRequest();

  constructor(
    private router: ActivatedRoute,
    private playerService: PlayerService,
    private telemetryService: TelemetryService,
    private breadcrumbService: BreadcrumbService,
    private token: TokenService,
    private projectSidebarService: ProjectSidebarService,
    private confirmationService: ConfirmationService
  ) {
  }

  ngOnInit() {
    this.loading = true;

    this.searchTerms.pipe(
        debounceTime(1000),
        distinctUntilChanged())
        .subscribe(value => {
          this.dt.reset();
        });

    this.router.parent.params.subscribe((params) => {
      this.projectId = params.id;
    });
    this.router.params.subscribe((data) => {
      this.playerId = data.id;
    });
    this.router.parent.data.subscribe(
      (data) => {
        if (data.project) {
          this.project = Object.assign({}, data.project);
          this.getPlayer();
          this.projectSidebarService.setProject(this.project);
        }
        this.loading = false;
      }
    );
  }

  getPlayer() {
    this.playerQuery.projectId = this.projectId;
    this.playerService.getOne(this.playerId, this.playerQuery).subscribe(
      (playerData) => {
        this.player = playerData;

        this.breadcrumbService.setItems([
          {label: 'projects', routerLink: ['/project', 'list']},
          {label: this.project.name},
          {label: 'players', routerLink: ['/project', this.project.id, 'players']},
          {label: this.player.platformClientId},
        ]);
        this.loading = false;
      });
  }

  paginate(event: any) {
    this.telemetryQuery.page = (event.first / event.rows) + 1;
    this.telemetryQuery.sortField = event.sortField !== undefined ? event.sortField : 'name';
    this.telemetryQuery.sortDir = this.telemetryQuery.getSortDir(event.sortOrder);

    this.getTelemetry(this.telemetryQuery);
  }

  getTelemetry(query: any) {
    query.sortField = !query.sortField ? 'creationDate' : query.sortField;
    query.sortDir = !query.sortDir ? 'desc' : query.sortDir;

    this.loading = true;
    this.telemetryService.getTelemetryForPlayer(this.projectId, this.playerId, query)
      .subscribe(
        (data) => {
          this.telemetryResponse = data;
          this.loading = false;
        },
        (error) => {
          delete (this.loading);
          this.loading = false;
        }
      );
  }

  deleteEvents() {
    if (this.selectedEvents && this.selectedEvents.length > 0) {
      this.confirmationService.confirm({
        message: 'This action cannot be undone. Do you really want to delete the selected telemetry events?',
        accept: () => {
          this.loading = true;
          this.telemetryService.deleteTelemetryEvents(this.project.id, this.selectedEvents.map(x => x.id))
              .subscribe(
                  (data) => {
                    this.getTelemetry(this.playerQuery);
                  },
                  (error) => {
                    this.getTelemetry(this.playerQuery);
                  });
        }
      });
    }
  }

  showDialog(id: String) {
    this.displayDialog = true;
    for (let telemetry of this.telemetryResponse.content) {
      if (telemetry.customerData && telemetry.customerData.id === id) {
        this.modalContent = telemetry.customerData.data;
        return;
      }
    }
  }

}
